import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row, Button } from "react-bootstrap";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate, useParams, Link } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import { FaEdit } from "react-icons/fa";

const ViewPartnerCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getCategoryApi = Api({
    url: `admin/associate/partner/category/${id}`,
  });

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        if (id) {
          const response = await getCategoryApi.fetchDataBySingleId();
          if (response && response.data && response.data.statusType === "SUCCESS") {
            setInitialData(response.data.associatePartnerCategory);
          } else {
            showToast("Failed to fetch category details", { type: "error" });
            navigate("/partner-categories");
          }
        }
      } catch (error) {
        console.error("Error fetching category:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Partners", link: "/partners" },
    { label: "Partner Categories", link: "/partner-categories" },
    { label: "View Partner Category", link: "", active: true },
  ];

  if (isLoading || !initialData) {
    return (
      <Container fluid style={{ marginTop: "2rem", display: "flex", justifyContent: "center" }}>
        <Spinner loading={true} />
      </Container>
    );
  }

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <SingleDetailHeader
                header="View Partner Category"
                description={`View details for category ID: ${id}`}
              />
              <Link to={`/partner-categories/edit/${id}`} className="btn btn-primary d-flex align-items-center">
                <FaEdit className="me-2" /> Edit Category
              </Link>
            </div>
            
            <div className="card p-4 shadow-sm border-0 mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              <Row className="mb-4">
                <Col md={12}>
                  <h6 className="text-muted mb-1">Name</h6>
                  <p className="fs-5">{initialData.name || "N/A"}</p>
                </Col>
              </Row>
              
              <Row>
                <Col md={12}>
                  <h6 className="text-muted mb-1">Description</h6>
                  <p className="fs-5">{initialData.description || "N/A"}</p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ViewPartnerCategory;
